module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voip-card"
  }, [_c('div', {
    staticClass: "icon",
    class: _vm.cssClass
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.convert_number) + " " + _vm._s(_vm.suffix))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a452cf1!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/voip_report/card.vue
// module id = 1134
// module chunks = 1